import parkService from './ws';

export default parkService;